import * as React from 'react';

import Shield16 from './Shield16';

export const shield16 = () => <Shield16 />;

export default {
    title: 'Icon/Line/Shield16',
    component: Shield16,
    parameters: {
        notes: "`import Shield16 from 'box-ui-elements/es/icon/line/Shield16';`",
    },
};
